import React from 'react';

export default ({ color = '#221CB6' }) => (
  <svg width="24" height="23" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.92533 10H2.91699L3.58559 16.0174C3.67938 16.8614 4.39282 17.5 5.24207 17.5H7.50033"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66699 10.833V14.1663"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66699 6.66699H18.3337"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.29199 1.25L4.16699 6.66667H5.00033"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.709 1.25L15.834 6.66667H15.0007"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0543 13.5771L11.7596 13.8718C10.7833 14.8481 10.7833 16.4311 11.7596 17.4073C12.7359 18.3836 14.3188 18.3836 15.2952 17.4073L15.5898 17.1127"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4111 11.2202L14.7057 10.9255C15.682 9.9493 17.265 9.9493 18.2413 10.9255C19.2176 11.9019 19.2176 13.4848 18.2413 14.4611L17.9466 14.7557"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4111 14.7557L15.5896 13.5771"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
